import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(addToCartButtonStyles, {
    button: {
        sizeVariant: "large",
        css: css`
            width: auto;
            display: flex;
            align-items: center;
            justify-content: center;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["1", null, "0", null, null], properties: ["flex-grow"] }],
                    mediaOptions.min,
                )}
        `,
        typographyProps: {
            css: css`
                font-size: ${TYPOGRAPHY.size.base};

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [
                            {
                                values: [`${TYPOGRAPHY.size.base}`, null, `${TYPOGRAPHY.size.large}`, null, null],
                                properties: ["font-size"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
    },
});
